import { render } from "./createChallenge.html?vue&type=template&id=bbbf06de"
import script from "./CreateChallenge.vue?vue&type=script&lang=ts"
export * from "./CreateChallenge.vue?vue&type=script&lang=ts"
script.render = render

export default script